
import { createClient } from '@supabase/supabase-js'
const supabaseUrl = 'https://elwkarirhzlqhmiqhaer.supabase.co'
const supabaseKey = 'sb_publishable_bZtttSKF-aNyPl4zLXr6Gg_7cvmd3rc'
export const supabase = createClient(supabaseUrl, supabaseKey)